import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { z } from 'zod';

export const querySchema = z
  .object({
    district: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined))
      .optional(),
    discipline: z
      .string()
      .default('')
      .transform(x => {
        if (!x) return undefined;

        return x as 'sq' | 'bp' | 'dl' | 'total';
      })
      .pipe(z.enum(['sq', 'bp', 'dl', 'total']).optional()),
    competition_type: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined))
      .optional(),
    weight_class: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined))
      .optional(),
    sex: z.enum(['ALL', 'F', 'M']).default('ALL'),
  })
  .merge(paginationSchema);
